import SiteLayout from "@/components/feature/SiteLayout";
import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import ClientLoginForm from "@/pages/area-do-cliente/components/ClientLoginForm";

const BENEFITS = [
  {
    icon: "ri-server-line",
    title: "Gerencie seus serviços",
    description: "Veja o status da sua hospedagem, VPS, domínios e demais serviços contratados.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Faturas e pagamentos",
    description: "Acompanhe e pague as suas faturas de forma rápida e segura.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Abertura de tickets",
    description: "Fale com o nosso suporte e acompanhe os seus atendimentos em um só lugar.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Ambiente seguro",
    description: "O acesso é protegido e as suas informações ficam sempre em segurança.",
  },
];

export default function AreaDoCliente() {
  return (
    <SiteLayout>
      <Seo
        title="Login da Área do Cliente | NXHOST"
        description="Acesse a Área do Cliente NXHOST para gerenciar hospedagem, VPS, domínios, faturas e atendimentos. Entre com o seu e-mail e senha com segurança."
        keywords="área do cliente NXHOST, login NXHOST, painel do cliente, gerenciar hospedagem, faturas"
        path="/area-do-cliente"
        titleEn="Client Area Login | NXHOST"
        titleEs="Inicio de Sesión del Área de Cliente | NXHOST"
        descriptionEn="Log in to the NXHOST Client Area to manage hosting, VPS, domains, invoices and support tickets. Sign in securely."
        descriptionEs="Inicia sesión en el Área de Cliente de NXHOST para gestionar hosting, VPS, dominios, facturas y soporte de forma segura."
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Área do Cliente", path: "/area-do-cliente" },
        ]}
      />

      <PageHero
        badge="Área do Cliente"
        badgeIcon="ri-user-3-line"
        title="Acesse a sua Área do Cliente."
        subtitle="Gerencie os seus serviços, faturas, domínios e atendimentos em um painel único e seguro. Entre com o seu e-mail e a sua senha."
        crumbs={[{ label: "Início", to: "/" }, { label: "Área do Cliente" }]}
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16">
            <Reveal>
              <ClientLoginForm />
            </Reveal>

            <Reveal delay={120}>
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
                  <i className="ri-dashboard-3-line" aria-hidden="true"></i>
                  O que você encontra por aqui
                </span>
                <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                  Tudo o que você precisa, em um só lugar.
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  Na Área do Cliente você acompanha e administra a sua estrutura digital de forma
                  simples e rápida.
                </p>

                <ul className="mt-8 flex flex-col gap-4">
                  {BENEFITS.map((benefit) => (
                    <li key={benefit.title} className="flex items-start gap-4">
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                        <i className={`${benefit.icon} text-xl`} aria-hidden="true"></i>
                      </span>
                      <div>
                        <p className="font-heading text-sm font-semibold text-foreground-950">
                          {benefit.title}
                        </p>
                        <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                          {benefit.description}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 rounded-xl border border-background-200 bg-background-100/70 p-5">
                  <p className="text-sm text-foreground-700">
                    Ainda não é cliente? Fale com a nossa equipe e conheça as soluções da NXHOST.
                  </p>
                  <Link
                    to="/contato"
                    className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
                    Falar com um especialista
                  </Link>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}